// eslint-disable-next-line max-len
var WEATHER_SUN_FILLED = 'm32,14.92v2h-4.26v-2h4.26Zm-27.74,0H0v2h4.26v-2Zm10.74,12.74v4.26h2v-4.26h-2Zm2-23.47V-.08h-2v4.26h2Zm8.01,4.14l3.01-3.01-1.41-1.41-3.01,3.01,1.41,1.41ZM6.99,23.52l-3.01,3.01,1.41,1.41,3.01-3.01-1.41-1.41Zm16.6,1.41l3.01,3.01,1.41-1.41-3.01-3.01-1.41,1.41ZM8.41,6.92l-3.01-3.01-1.41,1.41,3.01,3.01,1.41-1.41Zm7.59-.47c-5.25,0-9.5,4.25-9.5,9.5,0,5.25,4.25,9.5,9.5,9.5,5.25,0,9.5-4.25,9.5-9.5,0-5.25-4.25-9.5-9.5-9.5Z';

export { WEATHER_SUN_FILLED };
//# sourceMappingURL=WEATHER_SUN_FILLED.js.map
